var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "stationDailyDiscountData",
          attrs: {
            id: "stationDailyDiscountData",
            data: _vm.stationDailyDiscountData,
            "highlight-current-row": "",
            height: "600",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c(
            "el-table-column",
            { attrs: { fixed: "", align: "center", label: "站点" } },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  label: _vm.selectedArea,
                  align: "center",
                  "column-key": "area",
                  filters: _vm.filterMapping,
                  "filter-multiple": false,
                  "filter-placement": "right",
                  "filter-method": _vm.filterHandler
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.sellerName(scope.row.sellerId)) + " "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                align: "center",
                label:
                  "日期：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月DD日")
              }
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "dayNums", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumDiscount",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice",
                  label: "总均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice92",
                  label: "92#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice95",
                  label: "95#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice0",
                  label: "0#均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                align: "center",
                label:
                  "月份：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月")
              }
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "monthNums", label: "总升数" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthSumDiscount",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffDiscountPrice",
                  label: "总均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffDiscountPrice92",
                  label: "92#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffDiscountPrice95",
                  label: "95#均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "monthDiffDiscountPrice0",
                  label: "0#均价"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }